import { lightenHex } from '../formatters/colorAlpha';

export function buildGradientId(chartId: string, index: number): string {
  return `hustro-chart-grad-${chartId}-${index}`;
}

export function buildGaugeGradientId(
  chartId: string,
  gaugeIndex: number
): string {
  return `hustro-chart-gauge-grad-${chartId}-${gaugeIndex}`;
}

export function getSliceGradientFill(chartId: string, index: number): string {
  return `url(#${buildGradientId(chartId, index)})`;
}

export function getGaugeGradientFill(
  chartId: string,
  gaugeIndex: number
): string {
  return `url(#${buildGaugeGradientId(chartId, gaugeIndex)})`;
}

export type GradientStop = Readonly<{
  id: string;
  baseColor: string;
}>;

export function buildSliceGradientStops(
  chartId: string,
  colors: readonly string[]
): GradientStop[] {
  return colors.map((baseColor, index) => ({
    id: buildGradientId(chartId, index),
    baseColor,
  }));
}

export function getGradientLightColor(baseColor: string): string {
  return lightenHex(baseColor, 0.35);
}
